import { HubUserAttributesClient } from 'frontend-preferences-client';
const hubSettingsClient = HubUserAttributesClient.forCaller('dashboard-ui-components');
export const getSettings = keys => {
  const defaults = keys.reduce((next, key) => Object.assign({
    [key]: 'false'
  }, next), {});
  return hubSettingsClient.batchFetch(defaults);
};
export const setSetting = (key, value) => hubSettingsClient.write(key, value);